<template>
  <div class="configurable__container">
    <div class="configurable__sizes">
      <button
        class="configurable__title button no-hover"
        data-testid="configurable-sizes"
        @click="sizesOpen = !sizesOpen"
      >
        <span
          v-if="selectedOption"
          v-text="`${attribute.label}: ${selectedOption.label}`"
        />
        <span
          v-else
          v-text="attribute.label"
        />
        <IconArrow class="icon icon--arrow" />
      </button>
    </div>
    <div
      v-show="sizesOpen"
      ref="options"
      class="configurable__options"
    >
      <button
        type="button"
        class="button button button--icon-only no-hover"
        @click="sizesOpen = !sizesOpen"
      >
        <IconArrow class="icon icon--arrow" />
      </button>
      <ul class="configurable__list">
        <li v-if="parentType === 'GroupedProduct'">
          <input
            :id="product.id + '_clear'"
            class="configurable__input"
            type="radio"
            :name="product.id + '_' + attribute.attribute_code"
            value=""
            @click="clear"
          >
          <label
            :for="product.id + '_clear'"
            class="configurable__label configurable__unselect"
          >
            <span
              class="configurable__value"
              v-text="unselectLabel"
            />
          </label>
        </li>
        <ProductConfigurableAttributeOption
          v-for="option in attribute.values"
          :key="`${product.id}_${attribute.attribute_code}_${option.value_index}`"
          :product="product"
          :attribute="attribute"
          :option="option"
          :selected-options="selectedOptions"
          class="configurable__item"
          @selected="selected"
        />
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MagentoConfigurableProduct, MagentoConfigurableProductOption, MagentoConfigurableProductOptionsValue } from '~layers/app/types/magento'

export interface Props {
  product: MagentoConfigurableProduct
  attribute: MagentoConfigurableProductOption
  selectedOptions?: Record<string, MagentoConfigurableProductOptionsValue>
  parentType?: string
}
const props = defineProps<Props>()

const emit = defineEmits<{
  selected: Record<string, MagentoConfigurableProductOptionsValue | null>
}>()

const { t } = useI18n()

const selectedOption = computed<MagentoConfigurableProductOptionsValue | null>(() =>
  props.selectedOptions[props.attribute.attribute_code] || null,
)

const selected = (option: MagentoConfigurableProductOptionsValue) => {
  emit('selected', { [props.attribute.attribute_code]: option }, option)
  sizesOpen.value = !sizesOpen.value
}

const clear = () => {
  emit('selected', { [props.attribute.attribute_code]: null })
  sizesOpen.value = !sizesOpen.value
}

const unselectLabel = computed<string>(() => {
  const selectedOption = props.selectedOptions?.[props.attribute.attribute_code] || null
  if (selectedOption) {
    return t('Unselect')
  }
  return t('Choose your size')
})

// interaction
const sizesOpen = ref(false)
const options = ref(null)

onClickOutside(options, () => {
  sizesOpen.value = false
})
</script>

<style>
@import url("~layers/app/components/Product/ConfigurableAttribute.css");
</style>
